import React from "react";
import Modal from "react-bootstrap/Modal";
import useToggle from "../../../Hooks/useToggle";

export default function AcceptenceModal() {
  const [show, toggleShow] = useToggle(false);

  return (
    <>
      <p
        onClick={toggleShow}
        style={{ fontSize: "0.75rem", color: "grey", marginLeft: "0.5rem" }}
      >
        <b>(ver terminos aqui)</b>
      </p>

      <Modal
        show={show}
        keyboard={false}
        onHide={toggleShow}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <p>
            La empresa se compromete y acepta lo siguiente:
            <ul>
              <li>
                Publicar vacantes, pasantías y/o cursos gratuitos e interactuar
                con los jóvenes incluidos en la plataforma KREZCO
              </li>
              <li>
                Autorizar la inclusión del logotipo de la empresa en la
                plataforma KREZCO
              </li>
              <li>
                Cumplir con lo establecido en las Políticas y normativas de
                Children Believe Fund relacionadas con la Política de
                Salvaguarda de la Niñez, Política de Protección contra la
                Explotación Sexual y Abuso (PESA) y la Política de Género (Anexo
                B) y la Política de Confidencialidad (Incluir enlace para acceso
                a estas políticas)
              </li>
              <li>
                Establecer mecanismos para salvaguardar contra la violación y el
                abuso de los jóvenes registrados en la plataforma, incluida la
                explotación y el abuso sexual.{" "}
              </li>
              <li>
                Utilizar lenguaje y contenido apropiado para la juventud, de
                forma neutral
              </li>
              <li>
                Abstenerse de publicar o promover cuestiones o actividades que
                generen como resultado proselitismo político o religioso
              </li>
            </ul>
            <br />
            <b>
              Sobre los derechos de propiedad intelectual y descargo de
              responsabilidad
            </b>
            <br />
            <br />
            <span style={{ fontStyle: "italic" }}>
              Derechos de propiedad intelectual
            </span>
            <br />
            Todo el contenido de la Plataforma KREZCO, entre ellos y solo bajo
            una lista enunciativa, textos, ilustraciones, gráficas, animaciones,
            vídeos y sonidos, están protegidos por los derechos de propiedad
            intelectual y todos los derechos corresponden exclusivamente a
            Children Believe Fund. Estos contenidos no pueden copiarse,
            distribuirse, modificarse ni ponerse a disposición de terceros sin
            ningún fin, ya sea comercial o didáctico o de otra índole sin el
            consentimiento por escrito de Children Believe Fund. Hemos de
            señalar, además, que las imágenes que figuran en la Plataforma
            KREZCO están sujetas a derechos de propiedad.
            <br />
            <br />
            <span style={{ fontStyle: "italic" }}>Derechos de marcas</span>
            <br />
            Salvo que se indique lo contrario, todas las marcas registradas en
            la Plataforma KREZCO están protegidas por los derechos de marca.
            Esto se aplica, en especial, a las marcas, denominaciones de
            modelos, logotipos y emblemas que se usen, o se incorporen en un
            futuro a la Plataforma KREZCO.
            <br />
            <br />
            <span style={{ fontStyle: "italic" }}>Responsabilidad civil</span>
            <br />
            Todo el contenido de la Plataforma KREZCO y las informaciones que se
            facilitan en ella se someterán a una cuidadosa selección y se
            actualizarán de manera regular. A pesar de eso, no podemos
            garantizar la actualización, corrección y exactitud de toda la
            información que contiene. Se eximirá a la organización de toda
            responsabilidad por daños que genere el uso de la plataforma de
            manera directa o indirecta siempre que no sea por dolo o negligencia
            grave. En el pleno y perfecto entendido de que está diseñada para un
            propósito de buena fe, educativo, social y progresista, por lo que
            no se hace responsable del mal uso.
            <br />
            <br />
            <span style={{ fontStyle: "italic" }}>Enlaces</span>
            <br />
            La Plataforma KREZCO puede incluir contenidos de terceros, logos o
            enlaces a otras páginas web sobre cuyos contenidos no tenemos
            control alguno. Dichos contenidos y enlaces se proporcionan
            exclusivamente para comodidad e información del usuario. Children
            Believe Fund no tiene ningún control, no asume ninguna
            responsabilidad, ni contractual, ni extra contractual, ni de
            reparación de daños o posible perjuicio, ni ofrece ninguna garantía
            ni emite ninguna declaración con respecto a los contenidos, logos o
            a las páginas web de terceros, a los cuales el usurario accede bajo
            su total responsabilidad. Por este motivo, no podemos ofrecerle
            garantías sobre dichos contenidos. El responsable del contenido de
            las páginas a las que remiten los enlaces será siempre el proveedor
            o gestor de ellas. Estas páginas fueron revisadas por el equipo
            técnico del proyecto EMPUJE para garantizar que está en línea con
            los fines de la plataforma KREZCO. En aquel momento, no se
            detectaron contenidos ilegales. Sin embargo, no es exigible el
            control permanente de los contenidos de estas páginas si no se
            tienen indicios concretos de que se ha vulnerado algún derecho. Si
            llegara a nuestro conocimiento que tal vulneración se ha cometido,
            eliminaremos de inmediato los enlaces afectados.
            <br />
            <br />
            <span style={{ fontStyle: "italic" }}>
              Exclusión de responsabilidad
            </span>
            <br />
            Dentro del marco permitido por la ley, Children Believe Fund, sus
            directores o empleados no se hacen responsables ante cualquier
            usuario, sea este natural o jurídico, de pérdidas directas o
            indirectas, responsabilidades, costos, reclamos, gastos o daños de
            cualquier tipo, ni contractual ni extracontractualmente, incluidos
            los casos de negligencia o que se ocasionen de alguna otra manera
            con motivo del uso de todas o de parte de los contenidos de la
            Plataforma KREZCO, como textos, ilustraciones, gráficas,
            animaciones, vídeos y sonidos, etc., o en relación con ellas. Por
            este medio, confirmo haber leído, entendido y aceptado las
            condiciones establecidas para el registro en la Plataforma
          </p>

          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={toggleShow}
              className="btn btn--gradient btn__icon btn__icon--door"
            >
              Aceptar
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
